import useSWR from "swr";
import { customFetcher, extractReactTableData, fileDownload, formatDatetime, SchemaType } from "../../../utils";
import { IRack } from "../../../globals/interfaces";
import Card from "../../custom/Card";
import styled from "styled-components";
import useDataSummary from "../../../customHooks/useDataSummary";
import useMonthYear from "../../MonthYearPicker/useMonthYear";
import MonthYearPicker from "../../MonthYearPicker";
import useUnit from "../../../customHooks/useUnit";
import VirtualTable from "../../custom/VirtualTable";
import ModalViewDeleted from "./ModalViewDeleted";
import { useRef, useState } from "react";
import moment from "moment";
import ActionIcon from "../../custom/ActionIcon";
import TempControlPicker from "./TempControlPicker";


export default function Deleted({
    activeTab
}: {
    activeTab: string;
}) {

    const unit = useUnit();
    const { month, setMonth, year, setYear } = useMonthYear();
    const swrKey = (activeTab === `LOGGED` && month && year && unit) ? 
        `/deleted-rack-data?month=${month}&year=${year}&unit=${unit}` : null;
    const {
        data
    } = useSWR(swrKey, customFetcher<IRack & { tempSetting: string; }>, {
        fallbackData: []
    });

    const { summary, earliestDate, latestDate } = useDataSummary(data, 't_created');
    const tableRef = useRef();
    const [selectedId, setSelectedId] = useState<number>();
    const [modal, setModal] = useState(false);
    const rackItem = data.find(item => item.id === selectedId);
    const [filterTempSetting, setFilterTempSetting] = useState('');
    const renderData = (filterTempSetting && filterTempSetting !== 'NONE') ?
        data.filter(item => item.tempSetting === filterTempSetting) :
        data;

    const handleSelectItem = (id: number) => {
        setSelectedId(id);
        setModal(true)
    }

    const downloadData = () => {
        const schema: Array<SchemaType> = [, {
            key: 's_location',
            name: 'Location'
        }, {
            key: 's_mawb', 
            name: 'MAWB',
            mawb: true
        }, {
            key: 's_hawb',
            name: 'HAWB'
        }, {
            key: 'i_pieces',
            name: 'Pieces'
        }, {
            key: 's_destination',
            name: 'Destination'
        }, {
            key: 's_created_by',
            name: 'Created by'
        }, {
            key: 't_created',
            name: 'Created',
            datetime: true
        }, {
            key: 'Modified',
            name: 't_modified',
            datetime: true
        }, {
            key: 's_modified_by',
            name: 'Modified by'
        }, {
            key: 's_status',
            name: 'Status'
        }];

        const data = extractReactTableData(tableRef, [], schema);
        fileDownload(data, `Rack Deleted Data ${moment(month, 'M').format('MM')}-${year}`)
    }

    return (
        <div>
            <Card>
                <FlexContainer>
                    <MonthYearPicker
                        setMonth={setMonth}
                        setYear={setYear}
                    />
                    <TempControlPicker
                        filterTempSetting={filterTempSetting}
                        setFilterTempSetting={setFilterTempSetting}
                    />
                </FlexContainer>
                <FlexContainer between>
                    <h4>{summary}</h4>
                    <ActionIcon 
                        type={'download'}
                        onClick={downloadData}
                    />
                </FlexContainer>
                <VirtualTable<IRack>
                    data={renderData}
                    mapping={[{
                        name: 'Location',
                        value: 's_location'
                    }, {
                        name: 'MAWB',
                        value: 's_mawb',
                        s_mawb: true
                    }, {
                        name: 'HAWB',
                        value: 's_hawb'
                    }, {
                        name: 'Pieces',
                        value: 'i_pieces'
                    }, {
                        name: 'Destination',
                        value: 's_destination'
                    }, {
                        name: 'Created',
                        value: 't_created',
                        datetime: true,
                        utc: true
                    }, {
                        name: 'Created by',
                        value: 's_created_by'
                    }, {
                        name: 'Modified',
                        value: 't_modified',
                        datetime: true,
                        utc: true
                    }, {
                        name: 'Modified by',
                        value: 's_modified_by'
                    }, {
                        name: 'Status',
                        value: 's_status'
                    }]}
                    handleClick={item => handleSelectItem(item.id)}
                    numRows={10}
                    reactTableRef={tableRef}
                />  
                <ModalViewDeleted 
                    modal={modal}
                    setModal={setModal}
                    rackItem={rackItem}
                />
            </Card>
        </div>
    );
}

const FlexContainer = styled.div<{ between?: boolean }>`
    display: flex;
    justify-content: ${p => p.between ? 'space-between' : null};
    align-items: baseline;
    gap: 5px;
`;